// src/components/driver/data.jsx
import moment from "moment";
import { usStates, canadianProvinces, countryOptions, mexicanStates } from "./countryOptions";

/*================= Defaults (as you requested) ================= */
export const defaultDriverData = {
  firstName: "",
  middleName: "",
  surName: "",
  suffix: "",
  dob: "", // EXPECT: "YYYYMMDD" from your UI (keep as string)
  street1: "",
  street2: "",
  city: "",
  county: "",
  state: "",
  zip: "",
  country: "",
  driverState: "",
  driverLicense: "",
  sex: "",
};

export const foreignData = {
  firstName: "",
  middleName: "",
  surName: "",
  dob: "",
  suffix: "",
  street1: "",
  street2: "",
  city: "",
  county: "",
  state: "",
  zip: "",
  country: "",
  driverState: "",
  driverLicense: "",
  sex: "",
}

export const defaultConvictions = [];
export const defaultWithdrawals = [];
export const linkedConvictions = [];
export let alertMessages = [];
export let maintenanceMessages = [];
export let fromConvictionReview = false;
export let fcwdOnly = false;
export let isNewUser = false;
export let isCDLHolder = false;
export let isDown = "No";
export let nameMatch = "Yes";
export let dobMatch = "Yes";
export let errMessage = null;
export var updateWithdrawal = {};

export function setConvictionReview(val){
  fromConvictionReview = val;
}
export function setFcwdOnly(val){
  fcwdOnly = val;
}
export function setCDLHolder(val){
  isCDLHolder = val;
}
export function setNewUser(val){
  isNewUser = val;
}
export function setIsDown(val){
  isDown = val;
}
export function setNameMatch(val){
  nameMatch = val;
}
export function setDobMatch(val){
  dobMatch = val;
}
export function setAlerts(val){
  console.log("Setting alerts:",val);
  alertMessages = val;
}
export function setMaintenance(val){
  console.log("Setting messages:",val);
  maintenanceMessages = val;
}

export function setDefaultDriverData(data){
  console.log("Data received", data);
    var state = data?.PersonDetails?.MailingAddress?.State ?? data.MailingAddress?.State ?? "";
    defaultDriverData.firstName = data?.PersonDetails?.PersonName?.FirstName ?? "";
    defaultDriverData.middleName = data?.PersonDetails?.PersonName?.MiddleName ?? "";
    defaultDriverData.surName = data?.PersonDetails?.PersonName?.SurName ?? "";
    defaultDriverData.suffix = data?.PersonDetails?.PersonName?.Suffix ?? "";
    defaultDriverData.dob = data?.PersonDetails?.DOB ?? "";
    defaultDriverData.street1 = data?.PersonDetails?.MailingAddress?.Line1 ?? data.MailingAddress?.Line1 ?? "";
    defaultDriverData.street2 = data?.PersonDetails?.MailingAddress?.Line2 ?? data.MailingAddress?.Line2 ?? "";
    defaultDriverData.city = data?.PersonDetails?.MailingAddress?.City ?? data.MailingAddress?.City ?? "";
    defaultDriverData.county = data?.PersonDetails?.MailingAddress?.County ?? data.MailingAddress?.County ?? "";
    defaultDriverData.state = usStates.find(id => id.key === state)?.label
    ?? canadianProvinces.find(id => id.code === state)?.label?.slice(10)
    ?? mexicanStates.find(id => id.code === state)?.label?.slice(10)
    ?? state
    defaultDriverData.zip = data?.PersonDetails?.MailingAddress?.Zip ?? data.MailingAddress?.Zip ?? "";
    defaultDriverData.country = data?.PersonDetails?.MailingAddress?.Country ?? data.MailingAddress?.Country ?? "";
    defaultDriverData.driverState = data?.License?.JurisdictionOfIssue ?? "";
    defaultDriverData.driverLicense = data?.License?.LicenseNumber ?? "";
    defaultDriverData.sex = data?.PersonDetails?.PhysicalDetails?.Sex[0] ?? "";
    console.log("Default secured", defaultDriverData)
}
export function setForeignData(data, request){
  const dob = data?.PersonDetails?.DOB || defaultDriverData.dob || request?.DriverData?.DriverDOB || "";
  var state = data?.PersonDetails?.MailingAddress?.State ?? data.MailingAddress?.State ?? "";
  foreignData.dob =(moment(dob).format("YYYYMMDD") !== moment().format("YYYYMMDD") ? moment(dob).format("YYYYMMDD") : "");
  foreignData.firstName = data?.PersonDetails?.PersonName?.FirstName ?? request?.DriverData?.DriverName?.DriverFirstName ?? "";
  foreignData.middleName = data?.PersonDetails?.PersonName?.MiddleName ?? request?.DriverData?.DriverName?.DriverMiddleName ?? "";
  foreignData.surName = data?.PersonDetails?.PersonName?.SurName ?? request?.DriverData?.DriverName?.DriverLastName ?? "";
  foreignData.suffix = data?.PersonDetails?.PersonName?.Suffix ?? "";
  foreignData.street1 = data?.PersonDetails?.MailingAddress?.Line1 ?? data.MailingAddress?.Line1 ?? "";
  foreignData.street2 = data?.PersonDetails?.MailingAddress?.Line2 ?? data.MailingAddress?.Line2 ?? "";
  foreignData.city = data?.PersonDetails?.MailingAddress?.City ?? data.MailingAddress?.City ?? "";
  foreignData.county = data?.PersonDetails?.MailingAddress?.County ?? data.MailingAddress?.County ?? "";
  foreignData.state = usStates.find(id => id.key === state)?.label
  ?? canadianProvinces.find(id => id.code === state)?.label?.slice(10)
  ?? mexicanStates.find(id => id.code === state)?.label?.slice(10)
  ?? state
  foreignData.zip = data?.PersonDetails?.MailingAddress?.Zip ?? data.MailingAddress?.Zip ?? "";
  foreignData.country = data?.PersonDetails?.MailingAddress?.Country ?? data.MailingAddress?.Country ?? "";
  foreignData.driverState = data?.License?.JurisdictionOfIssue ?? request?.DriverLicense?.LicenseState ?? "";
  foreignData.driverLicense = data?.License?.LicenseNumber ?? request?.DriverLicense?.LicenseNumber ?? "";
  foreignData.sex = data?.PersonDetails?.PhysicalDetails?.Sex[0] ?? "";
  if(defaultDriverData.dob !== '' && foreignData.dob !== '' && foreignData.dob !== defaultDriverData.dob) {
    console.log("DOB different")
    setDobMatch('no')}
  if((foreignData.surName !== '' && defaultDriverData.surName !== '' && defaultDriverData.surName !== foreignData.surName) ||
    (foreignData.suffix !== '' && defaultDriverData.suffix !== '' && defaultDriverData.suffix !== foreignData.suffix) ||
    (foreignData.middleName !== '' && defaultDriverData.middleName !== '' && defaultDriverData.middleName !== foreignData.middleName) ||
    (foreignData.firstName !== '' && defaultDriverData.firstName !== '' && defaultDriverData.firstName !== foreignData.firstName)
  ){
    console.log("Name different")
    setNameMatch("no")
  }
  console.log("Foreign data set", foreignData);
}

export function setDefaultWithdrawals(withdrawals) {
    defaultWithdrawals.length = 0;
    defaultWithdrawals.push(...withdrawals);
}

export function setDefaultConvictions(convictions) {
    defaultConvictions.length = 0;
    defaultConvictions.push(...convictions);
}

export function setLinkedConvictions(convictionIds) {
  linkedConvictions.length = 0;
  const matchedConvictions = defaultConvictions.filter(conviction =>
    convictionIds.includes(conviction.ConvictionIdCode)
  );
  linkedConvictions.push(...matchedConvictions);
}
/*================= Small utilities ================= */
const defined = (v) => v !== undefined && v !== null && v !== "";
const pick = (obj) => Object.fromEntries(Object.entries(obj || {}).filter(([, v]) => defined(v)));

/*Your API wants "YYYYMMDD" strings. If you already store that, pass it through. */
export const toYMD = (d) => {
  console.log("toYMD input:", d);
  if(moment(d).isValid()){
    return moment(d).format("YYYYMMDD");
  }
  return d;
};


/*Always include Source; optionally pass { CAorMXDown: "Yes" } */
export const buildSource = (opts = {}) =>
  ({ Source: pick({ DataSource: opts.DataSource ?? 'StatesUI', CAorMXDown: opts.CAorMXDown ?? isDown, NameMatched: nameMatch, DOBMatch: dobMatch }) });

export const buildHeader = (opts = {}) =>
  ({ Header: pick({Metadata: { UserID: opts.userId}}) });

export function unmatchedData(d = defaultDriverData, f = foreignData){
  return{
    UnMatchedData:{
      SourceNameObj:{
        SurName: f.surName,
        FirstName: f.firstName,
        MiddleName: f.middleName,
        Suffix: f.suffix
      },
      ReqNameObj:{
        SurName: d.surName,
        FirstName: d.firstName,
        MiddleName: d.middleName,
        Suffix: d.suffix
      },
      DOBObject: {
        SourceDob: f.dob,
        ReqDob: d.dob
      }
    }
  }
}
/*Map your flat driver data into the API PersonDetails object */
export function makePersonDetails(d = defaultDriverData) {
  return {
    PersonDetails: {
      PersonName: {
        SurName: d.surName,
        FirstName: d.firstName,
        MiddleName: d.middleName,
        Suffix: d.suffix,
      },
      PhysicalDetails: { Sex: d.sex },
      DOB: d.dob !== '' ? toYMD(d.dob) : toYMD(foreignData.dob),
      SSN: d.ssn, // optional if you have it
      MailingAddress: {
        Line1: d.street1,
        Line2: d.street2,
        City: d.city,
        State: d.state,
        Zip: d.zip,
        County: d.county,
        Country: d.country,
      },
    },
  };
}

/*Map your flat driver data into the API License object */
export function makeLicense(d = defaultDriverData) {
  return {
    License: {
      JurisdictionOfIssue: d.driverState,
      LicenseNumber: d.driverLicense,
    },
  };
}

/*Build a convictions (single) record from your form */
export function makeConvictionRecord(c = {}, comment = "") {
  return {
    Convictions:{
      JurisdictionCodeConvicting: c.JurisdictionCodeConvicting,
      CitationDate: toYMD(c.CitationDate),
      ConvictionDate: toYMD(c.ConvictionDate),
      ConvictionCourtType: c.ConvictionCourtType.substring(0, 3),
      ConvictionCommercialVehInd: c.ConvictionCommercialVehInd?.split(' - ')[0],
      ConvictionHazmatInd: c.ConvictionHazmatInd?.split(' - ')[0],
      CDLIndicator: c.CitationCdlHolderIndicator?.split(' - ')[0],
      ConvictionJurisCourtReportId: c.ConvictionJurisCourtReportId,
      ConvictionJurisdictionOffenseCode: c.ConvictionJurisdictionOffenseCode,
      ConvictionOffenseAcdCode: c.ConvictionOffenseAcdCode?.Code,
      ConvictionOffenseDetailAcd: c.ConvictionOffenseDetailAcd,
      ConvictionStatusNotes: comment !== "" ? comment : c.ConvictionStatusNotes,
      ConvictionUserId: c.ConvictionUserID, //todo: update once user data is available
    },
  };
}

/*Build a convictions array for the withdrawal-add (endpoint 8) */
export function makeConvictionsArray(arr = []) {
  console.log("Convictions array", arr);
  return {
    Convictions: arr.map((c) =>
      ({
        JurisdictionCodeConvicting: c.JurisdictionCodeConvicting,
        CitationDate: toYMD(c.CitationDate),
        ConvictionDate: toYMD(c.ConvictionDate),
        ConvictionCourtType: c?.ConvictionCourtType?.split(' - ')[0],
        ConvictionCommercialVehInd: c?.ConvictionCommercialVehInd?.split(' - ')[0],
        ConvictionHazmatInd: c?.ConvictionHazmatInd?.split(' - ')[0],
        CDLIndicator: c?.CitationCdlHolderIndicator?.split(' - ')[0] ?? c.CDLIndicator,
        ConvictionJurisCourtReportId: c.ConvictionJurisCourtReportId,
        ConvictionJurisdictionOffenseCode: c.ConvictionJurisdictionOffenseCode,
        ConvictionOffenseAcdCode: c.ConvictionOffenseAcdCode?.Code ?? c.ConvictionOffenseAcdCode,
        ConvictionOffenseDetailAcd: c.ConvictionOffenseDetailAcd,
        ConvictionStatusNotes: c.ConvictionStatusNotes,
        ConvictionUserId: c.ConvictionUserID ?? c.ConvictionUserId,
      })
    ),
  };
}

/*Build a Withdrawals object (singular) from your form */
export function makeWithdrawalRecord(w = {}, comment = "") {
  console.log("Withdrawal sent", w.DLWithdrawalReinstatementDate);
  return {
    Withdrawals: {
      JurisdictionCodeWithdrawing: w.JurisdictionCodeWithdrawing,
      DriverLicenseWithdrawalEffectiveDate: toYMD(w.DriverLicenseWithdrawalEffectiveDate),
      DriverLicenseWithdrawalType: w.DriverLicenseWithdrawalType?.split(' - ')[0],
      DriverLicenseWithdrawalBasis: w.DriverLicenseWithdrawalBasis?.split(' - ')[0],
      DLWithdrawalDueProcessStatus: w.DLWithdrawalDueProcessStatus?.split(' - ')[0],
      DRVLicAcdWithdrawalReasonCode: w?.DRVLicAcdWithdrawalReasonCode?.Code ?? w?.DRVLicAcdWithdrawalReasonCode,
      DRVLicWithdrawalEligibilityDate: toYMD(w.DRVLicWithdrawalEligibilityDate),
      DLWithdrawalReinstatementDate: toYMD(w.DLWithdrawalReinstatementDate),
      DRVLicWithdrawalExtentIdDlc: w.DRVLicWithdrawalExtentIdDlc?.split(' - ')[0],
      DLWithdrawalJurisdictionReportId: w.DLWithdrawalJurisdictionReportId,
      DRVLicWithdrawalReasonReference: w.DRVLicWithdrawalReasonReference,
      WithdrawalCategory: w.WithdrawalCategory,
      WithdrawalNoticePeriod: w.WithdrawalNoticePeriod,
      WithdrawalDuration: w.WithdrawalDuration,
      WithdrawalReinstLetterSentDate: toYMD(w.WithdrawalReinstLetterSentDate),
      WithdrawalDisqLetterNeeded: w.WithdrawalDisqLetterNeeded,
      WithdrawalDisqLetterSentDate: toYMD(w.WithdrawalDisqLetterSentDate),
      WithdrawalDQLetterMailedDate: toYMD(w.WithdrawalDQLetterMailedDate),
      WithdrawalStatusNotes: comment !== "" ? comment : w.WithdrawalStatusNotes,
      WithdrawalDateReceived: toYMD(w.WithdrawalDateReceived),
      WithdrawalDatePosted: toYMD(w.DatePosted),
      WithdrawalID: w.DriverLicenseWithdrawalIdCode,
      WithdrawalId: w.DriverLicenseWithdrawalIdCode,
      WithdrawalUserId: w.WithdrawalUserId // todo: update from self when userdata available
    },
  };
}

/*Build a Withdrawal object (singular, not "Withdrawals") for endpoint 8 */
export function makeWithdrawalObjectForAdd(w = {}) {
  return {
    Withdrawals: {
      JurisdictionCodeWithdrawing: w.JurisdictionCodeWithdrawing,
      DriverLicenseWithdrawalEffectiveDate: toYMD(w.DriverLicenseWithdrawalEffectiveDate),
      DriverLicenseWithdrawalType: w.DriverLicenseWithdrawalType,
      DriverLicenseWithdrawalBasis: w.DriverLicenseWithdrawalBasis,
      DLWithdrawalDueProcessStatus: w.DLWithdrawalDueProcessStatus,
      DRVLicAcdWithdrawalReasonCode: w.DRVLicAcdWithdrawalReasonCode,
      DRVLicWithdrawalEligibilityDate: toYMD(w.DRVLicWithdrawalEligibilityDate),
      DLWithdrawalReinstatementDate: toYMD(w.DLWithdrawalReinstatementDate),
      DRVLicWithdrawalExtentIdDlc: w.DRVLicWithdrawalExtentIdDlc,
      DLWithdrawalJurisdictionReportId: w.DLWithdrawalJurisdictionReportId,
      DRVLicWithdrawalReasonReference: w.DRVLicWithdrawalReasonReference,
      WithdrawalCategory: w.WithdrawalCategory,
      WithdrawalNoticePeriod: w.WithdrawalNoticePeriod,
      WithdrawalDuration: w.WithdrawalDuration,
      WithdrawalReinstLetterSentDate: toYMD(w.WithdrawalReinstLetterSentDate),
      WithdrawalDisqLetterNeeded: w.WithdrawalDisqLetterNeeded,
      WithdrawalDisqLetterSentDate: toYMD(w.WithdrawalDisqLetterSentDate),
      WithdrawalDQLetterMailedDate: toYMD(w.WithdrawalDQLetterMailedDate),
      WithdrawalStatusNotes: w.WithdrawalStatusNotes,
      WithdrawalUserId: w.WithdrawalUserId,
      WithdrawalDateReceived: toYMD(w.WithdrawalDateReceived),
      WithdrawalDatePosted: toYMD(w.WithdrawalDatePosted),
    },
  };
}

/*3) Update FCWD Driver Info*/
export function buildUpdateFcwdDriverInfo({ driver, sourceOpts } = {}) {
  return {
    ...buildHeader(sourceOpts),
    Body:{
    ...buildSource(sourceOpts),
    ...makePersonDetails(driver),
    ...makeLicense(driver),
    }
  };
}

/*4) FCWD Driver Details*/
export function buildFcwdDriverDetails({ driver, sourceOpts } = {}) {
  return {
    ...buildHeader(sourceOpts),
    Body:{
    ...buildSource(sourceOpts),
    ...makeLicense(driver),
    }
  };
}

/*5) Add/Report a Conviction*/
export function buildAddConviction({ driver, foreign, conviction, sourceOpts = { CAorMXDown: "Yes" } } = {}) {
  return {
    ...buildHeader(sourceOpts),
    Body:{
    ...buildSource(sourceOpts), // includes CAorMXDown:"Yes" if you keep default
    ...makePersonDetails(driver),
    ...makeLicense(driver),
    ...makeConvictionRecord(conviction),
    ...unmatchedData(driver, foreign),
    }
  };
}

/*6) Negate Conviction— shape matches what you sent */
export function buildNegateConviction({ driver, conviction, comment, sourceOpts } = {}) {
  return {
    ...buildHeader(sourceOpts),
    Body:{
    ...buildSource(sourceOpts),
    ...makePersonDetails(driver),
    ...makeLicense(driver),
    ...makeConvictionRecord(conviction, comment),
    }
  };
}

/*8) Add a Withdrawal— includes Convictions[] + Withdrawal */
export function buildAddWithdrawal({ driver, foreign, convictions = [], withdrawal, sourceOpts = { CAorMXDown: "Yes" } } = {}) {
  return {
    ...buildHeader(sourceOpts),
    Body:{
    ...buildSource(sourceOpts), // includes CAorMXDown if provided
    ...makePersonDetails(driver),
    ...makeLicense(driver),
    ...makeConvictionsArray(convictions),
    ...makeWithdrawalObjectForAdd(withdrawal), // "Withdrawal" (singular) payload
    ...unmatchedData(driver, foreign),
    }
  };
}

export function buildAddStageWithdrawal({ driver,convictions = [], withdrawal, sourceOpts = { CAorMXDown: "Yes" } } = {}) {
  return {
    ...buildHeader(sourceOpts),
    Body:{
    ...buildSource(sourceOpts), // includes CAorMXDown if provided
    ...makePersonDetails(driver),
    ...makeLicense(driver),
    ...makeConvictionsArray(convictions),
    ...makeWithdrawalObjectForAdd(withdrawal), // "Withdrawal" (singular) payload
    }
  };
}

/*9) Negate Withdrawal— uses "Withdrawals" (plural object) per your sample */
export function buildNegateWithdrawal({ driver, withdrawal, comment, sourceOpts } = {}) {
  console.log("Received", driver, withdrawal, comment, sourceOpts);
  return {
    ...buildHeader(sourceOpts),
    Body:{
    ...buildSource(sourceOpts),
    ...makePersonDetails(driver),
    ...makeLicense(driver),
    ...makeWithdrawalRecord(withdrawal, comment), // "Withdrawals": {...}
    }
  };
}

export function buildNegateStageWithdrawal({ driver, withdrawal, comment, sourceOpts } = {}) {
  return {
    ...buildHeader(sourceOpts),
    Body:{
    ...buildSource(sourceOpts),
    ...makeLicense(driver),
    ...makeWithdrawalRecord(withdrawal, comment), // "Withdrawals": {...}
    }
  };
}

/*11) Update Withdrawal Details*/
export function buildUpdateWithdrawalDetails({ driver, withdrawal, sourceOpts } = {}) {
  // Requires License + Withdrawals{ WithdrawalID + updates }
  return {
    ...buildHeader(sourceOpts),
    Body:{
    ...buildSource(sourceOpts),
    ...makeLicense(driver),
    ...makeWithdrawalRecord(withdrawal),
    }
  };
}

/*12) Withdrawal Details*/
export function buildWithdrawalDetails({ driver, withdrawalId, sourceOpts } = {}) {
  return {
    ...buildHeader(sourceOpts),
    Body:{
    ...buildSource(sourceOpts),
    ...makeLicense(driver),
    WithdrawalID: withdrawalId,
    }
  };
}

export function buildConvictionDetails({ driver, convictionId, sourceOpts } = {}) {
  return {
    ...buildHeader(sourceOpts),
    Body:{
    ...buildSource(sourceOpts),
    ...makeLicense(driver),
    ConvictionID: convictionId,
    }
  };
}

/*13) Link Conviction(s) to Withdrawal*/
export function buildLinkConvictionsToWithdrawal({ driver, withdrawalId, convictionIds = [], sourceOpts } = {}) {
  return {
    ...buildHeader(sourceOpts),
    Body:{
    ...buildSource(sourceOpts),
    ...makeLicense(driver),
    WithdrawalID: withdrawalId,
    ConvictionIds: convictionIds,
    }
  };
}

/*14) Remove Link(s) from Withdrawal*/
export function buildRemoveLinksFromWithdrawal({ driver, withdrawalId, sourceOpts } = {}) {
  return {
    ...buildHeader(sourceOpts),
    Body:{
    ...buildSource(sourceOpts),
    ...makeLicense(driver),
    WithdrawalID: withdrawalId,
    }
  };
}

export async function postJson(url, payload, init, token) {

  console.log("PPP: "+JSON.stringify(payload))
  const { responseType, ...fetchInit } = init || {};
  const res = await fetch(url, {
    method: "POST",
    headers: { 
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`
     },
    body: JSON.stringify(payload),
    ...fetchInit,
  });
  if (!res.ok) {
    console.log("Response not ok")
    const text = await res.text().catch(() => "");
    if(res.statusText === "Internal Server Error"){return -1}
    throw new Error(`HTTP ${res.status}: ${text || res.statusText}`);
  }
  if (responseType === "blob") {
    console.log("Returning blob")
    return res.blob();
  }

  if (responseType === "arrayBuffer") {
    return res.arrayBuffer();
  }
  return res.json();
}

export function generateWdLocatorRef() {
  const ts = Date.now().toString(16).slice(-12).padStart(12, "0"); 
  const rand = Math.floor(Math.random() * 0xffff)
      .toString(16)
      .padStart(4, "0");
  return ts + rand; // always 16 chars
  }
export function generateReasonRefCode(prefix = "FH") {
  const num = Math.floor(Math.random() * 1_000_000)
      .toString()
      .padStart(6, "0");
  return `${prefix}${num}`; // e.g. FH150544
}

export function generateData(data) {
  // Collect keys whose value is exactly "INVALID" (legacy behavior)
  return Object.keys(data).reduce((result, key) => {
    const value = data[key];
    if (typeof value === "string") {
      if (value === "INVALID") {
        if (key === "LicenseNumber") return result;
        if (key === "DriverFirstName" && defaultDriverData.firstName === "") return result;
        result.push(key);
      }
    } else if (value && typeof value === "object") {
      result.push(...generateData(value));
    }
    return result;
  }, []);
}

export function toPascalCaseWithHyphens(str) {
  // 1. Split the string by the hyphen delimiter.
  const words = str.split(/[-\s]+/);

  // 2. Map over the array of words, capitalizing the first letter of each word
  //    and making the rest of the letters lowercase.
  const pascalCasedWords = words.map(word => {
    if (word.length === 0) {
      return '';
    }
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  });

  // 3. Join the words back together into a single string without spaces or hyphens.
  return pascalCasedWords.join(str.includes(' ') ? ' ' : '-');
}

export function setErr(message){
  errMessage = message;
  // if(message.includes("Driver is a CDL Holder") || message.includes("Data is from FCWD. If CMV = Yes, add to FCWD.")){
  //   return (<span>{message}</span>)
  // } else{
  //   return (<span style={{color:'red'}}>{message}</span>)
  // }
}